import { render, staticRenderFns } from "./shots-table.vue?vue&type=template&id=78856bd0&scoped=true&lang=pug&"
import script from "./shots-table.vue?vue&type=script&lang=ts&"
export * from "./shots-table.vue?vue&type=script&lang=ts&"
import style0 from "./shots-table.vue?vue&type=style&index=0&id=78856bd0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78856bd0",
  null
  
)

export default component.exports